<div class="jumbotron">
    <h1 class="text-center">2x2 Report</h1>
    <cmps-client-logo></cmps-client-logo>
</div>
<div class="reports-content">
    <ngb-tabset
        activeId="w-tab-report-0"
        #tabSet="ngbTabset"
    >
        <ngb-tab id="w-tab-report-0">
            <ng-template ngbTabTitle>
                <cmps-icon
                    class="legacy:cmps-cdk-fill-green-100"
                    svgIcon="chart-box-outline"
                ></cmps-icon>
                Select Parameters
            </ng-template>
            <ng-template ngbTabContent>
                &nbsp;
                <div class="p-3">
                    <div
                        cmpsReportsTbytSelection
                        (generated)="onGeneratedReport($event)"
                        (changed)="onChanged()"
                        [roleList]="roleList"
                        [rawDates]="rawDates"
                        [pendingData]="pendingData"
                        [metricsBehaviours]="metricsBehaviours"
                        [metricsOutcomes]="metricsOutcomes"
                        [params]="params"
                    ></div>
                </div>
            </ng-template>
        </ngb-tab>
        <ngb-tab id="w-tab-report-1">
            <ng-template ngbTabTitle>
                <cmps-icon
                    class="legacy:cmps-cdk-fill-green-100"
                    svgIcon="file-document"
                ></cmps-icon>
                2x2
            </ng-template>
            <ng-template ngbTabContent>
                <div
                    class="p-3"
                    *ngIf="params.pendingData"
                >
                    <cmps-wait-status></cmps-wait-status>
                    <h2 class="text-center">Report is being generated</h2>
                </div>

                <div
                    class="p-3"
                    *ngIf="!params.pendingData && params.noData"
                >
                    <h3 class="text-center">
                        There is no data generated for this report
                    </h3>
                </div>

                <div
                    class="p-3"
                    *ngIf="!params.pendingData && !params.noData"
                >
                    <div>
                        <button
                            class="btn-mini"
                            title="Refresh"
                            (click)="getReportResult()"
                        >
                            <cmps-icon svgIcon="refresh"></cmps-icon>
                        </button>
                    </div>
                    <div
                        class="reports-content container"
                        cmpsScatterPlot
                    ></div>
                </div>
            </ng-template>
        </ngb-tab>
    </ngb-tabset>
</div>
